import { Component, OnInit } from '@angular/core';
import { PageTitleService } from '../core/page-title/page-title.service';
import { ChkService } from '../service/chk.service';
import { Title, Meta } from '@angular/platform-browser';

@Component({
  selector: 'angly-contact',
  templateUrl: './contact.component.html',
  styleUrls: ['./contact.component.scss']
})
export class ContactComponent implements OnInit {

  /* Variables */
  title = 'Contact Us- Encriss Technologies';
  contact : any;
  
  // lat: number = 21.453069;
  // lng: number = 180.253911;
  lat= 40.178873;
  lng= -11.821675;
  zoom:number = 2;
  draggable = false;
  gestureHandling: 'none';
  zoomControl: false

  coordinates=[
    {
      lat: 28.467478,
      lng: 77.081481,
      label:"C",
      place:"712, Galleria Towers, DLF Phase IV, Sector 28, Gurgaon, HR(122009)",
      number: "+91 98107 89998"
    },
    {
      lat: 49.286870,
      lng: -123.126740,
      label: "B",
      place: "1200, Alberni Street, Vancouver,BC(V6E 1A6)" ,
      number:"+1 (604) 339-4276"
    },
    {
      lat: 43.497390,
      lng: -80.547260,
      label: "A",
      place: "180 Northfield Dr W Unit 4, Waterloo, ON N2L 0C7, Canada" ,
      number:"+1 (519) 497-9283" 
    }
  ]
  
  constructor( 
    private pageTitleService: PageTitleService, 
    private service:ChkService,
    private titleService: Title, 
    private meta: Meta 
    ) {

    /* Page title */
    this.pageTitleService.setTitle(" Get In Touch With Us!");
    //this.pageTitleService.setBgImg("../assets/img/services/springboot/java.jpg");

    /* Page subTitle */
    // this.pageTitleService.setSubTitle(" Our latest news and learning articles. ");

    this.service.getContactContent().
      subscribe(response => {this.contact = response},
                err      => console.log(err),
                ()       => this.contact
            );
  }

  ngOnInit() {
    this.titleService.setTitle(this.title);
    this.meta.updateTag({
      name: 'keywords',
      content: 'Web Application Company, Top Website Designing Company,Best Web Development Companies, Website Design Company in India, Web Development Service in India, Web Solutions Companies, Top Web Design Companies, Web Development Company in Delhi, Website Design Agency, Web Applications, Web Portal, Mobile App Development, Mobile Application Development India, App Development Company, Mobile App Developers, Mobile App Development Company India, Mobile Apps Development Services, Mobile Application Developer, Android App Development Cost, Mobile App Development, App Development India, Mobile App Developers India, Mobile Apps Development Company Gurgaon, Mobile App Workflow, Best Mobile Apps Development in India, Mobile Apps Development NCR, Andriod App Workflow, Cutting Edge IOS App, Ios App Work Flow, Ios App Design, Ios App Development, Cutting Edge App, Best IOS Mobile Apps, All in One Software Development Services, Best Erp Solution in India, Best Software Development Company in India, Java Spring Boot, Java Spring Boot Development in India, Spring Boot Implementation, Java Spring Boot Company in India, Spring Boot Java T Point, Spring Framework Module in India, New Development Model in India, Spring Boot Documentation, Online Digital Marketing, SEO Experts in India, , Digital Agency in Delhi, Digital Agency in India, Digital Marketing Company Gurgaon, Social Media Marketing, Top10 Digital Marketing Company, Best Digital Marketing Company in India, E-Commerce Platform For Online Stores, Best Ecommerce Platform, B2B Ecommerce Platform, Top Ecommerce Platform, Ecommerce Store, Best Ecommerce Platform For Startups, Ecommerce Mobile App'
    });
  }

}
